import { ProductType, RouteName } from '@/shared/enums';
import router from '@/index/router';
import link from '@/index/shared/filters/link';
import i18n from '@/shared/i18n';

function getBreadcrumbs(product) {
  if (product.type === ProductType.EPISODE) {
    const serial = product.season.serial;
    const serialRoute = link(serial);

    return createBreadcrumbs(product, {
      name: serial.title,
      href: router.resolve(serialRoute).href,
    });
  }
  return createBreadcrumbs(product);
}

const createBreadcrumbs = (product, middleLayer) => {
  const mainCategory = product.mainCategory || {};
  const productRoute = link(product);
  const label = mainCategory.label || router.currentRoute.params.label;

  const catalogRoute = {
    name: RouteName.CATALOG,
    params: {
      label,
    },
  };

  const breadcrumbs = [
    {
      name: i18n.t(`glossary.${router.currentRoute.params.label}`),
      href: router.resolve(catalogRoute).href,
    },
    {
      name: product.title,
      href: router.resolve(productRoute).href,
    },
  ];

  if (middleLayer) {
    breadcrumbs.splice(1, 0, middleLayer);
  }

  return getBreadcrumbsListSchema(breadcrumbs);
};

const getBreadcrumbsListSchema = (breadcrumbs) => ({
  '@context': 'https://schema.org/',
  '@type': 'BreadcrumbList',
  itemListElement: breadcrumbs
    .map(({ name, href }, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name,
      item: `${window.location.origin}${href}`,
    })),
});

export function breadcrumbsSchema(product) {
  const seoBreadcrumbsElement = document.getElementById('seoBreadcrumbs');

  if (seoBreadcrumbsElement) {
    seoBreadcrumbsElement.innerText = JSON.stringify(getBreadcrumbs(product));
  }
}
